// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + "dd338b559c70010995b3" + ".js";
};